/**
 * The colours area pricing speaks in, in one place.
 *
 * Green means "costs less", and only that. Selection stays the funnel's blue
 * everywhere, so a cheaper option and a chosen one are never the same mark.
 *
 * A light green, as asked: the fill and the marks are bright, and only the
 * text steps down to a shade that still reads at 10px — #15803d is 5:1 on
 * white and 4.7:1 on the tint, where the brighter green would be 3.3:1.
 */
export const SAVINGS = {
  /** Prices and short labels. */
  ink: "#15803d",
  /** Dots and other marks that are not text. */
  mark: "#22c55e",
  /** Behind a cheaper day, and behind a line that says you save. */
  tint: "#effbf4",
  edge: "#bfeccf",
  /** A saving printed on a selected (blue) tile or button. */
  onBlue: "#c7f5d9",
};

/** The amber the funnel uses for a charge the customer can avoid. */
export const FEE = {
  ink: "#96590c",
  tint: "#fff9f0",
  edge: "#f2dcb9",
};

/** The cart's own indigo, which a tinted total settles back to. */
export const CART_INK = "#323593";
